import React from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import ToggleModalSkeleton from '../../components/Skeletons/ToggleModalSkeleton';

const ToggleOrgActive = ({
	toggleOrgModal,
	loading,
	deleteOrgData,
	handleToggleModalClose,
	handleOrgToggle
}) => {
	return (
		<Modal show={toggleOrgModal}>
			<ModalHeading
				heading={`${deleteOrgData.active ? 'Deactivate' : 'Activate'} ${deleteOrgData.name} Account`}
			/>
			{loading ? (
				<ToggleModalSkeleton />
			) : (
				<ModalForm style={{ marginBottom: '2.5rem' }}>
					<InputsSection style={{ width: '34rem' }}>
						{deleteOrgData.active ? (
							<p className='primaryText'>
								Deactivating will restrict {deleteOrgData.name} to log in to account.<br /> Are you sure you want to
								proceed?
							</p>
						) : (
							<p className='primaryText'>
								Activating will allow {deleteOrgData.name} to log in to account.<br /> Are you sure you want to
								proceed?
							</p>
						)}
					</InputsSection>
					<ModalButtons
						submitButtonLabel={`${deleteOrgData.active ? 'Deactivate Client' : 'Activate Client'}`}
						onSubmit={() => handleOrgToggle(deleteOrgData._id, deleteOrgData.active)}
						cancelButtonLabel='Cancel'
						onCancel={handleToggleModalClose}
					/>
				</ModalForm>
			)}
		</Modal>
	);
};

export default ToggleOrgActive;
